var monthNames = {
  'sv-SE': ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
  'nb-NO': ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
  'da-DK': ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
  'fi-FI': ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayShortNames = {
  'sv-SE': ['MÅ', 'TI', 'ON', 'TO', 'FR', 'LÖ', 'SÖ'],
  'nb-NO': ['MA', 'TI', 'ON', 'TO', 'FR', 'LØ', 'SØ'],
  'da-DK': ['MA', 'TI', 'ON', 'TO', 'FR', 'LØ', 'SØ'],
  'fi-FI': ['MA', 'TI', 'KE', 'TO', 'PE', 'LA', 'SU'],
  en: ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU']
};
var dayNames = {
  'sv-SE': ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag'],
  'nb-NO': ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'],
  'da-DK': ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'],
  'fi-FI': ['Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai', 'Sunnuntai'],
  en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
};
var weekPrefix = {
  'sv-SE': 'V.',
  'nb-NO': 'U.',
  'da-DK': 'U.',
  'fi-FI': 'V.',
  en: 'W.'
};

export { dayNames, dayShortNames, monthNames, weekPrefix };
//# sourceMappingURL=texts.js.map
